// Mock data para el menú del restaurante

export const menuCategories = [
  {
    id: 1,
    name: "Hamburguesas Gourmet",
    slug: "burgers",
    description: "Carne premium, ingredientes frescos, sabor inolvidable",
    image: "https://images.unsplash.com/photo-1550547660-d9450f859349",
    items: [
      {
        id: 101,
        name: "Classic Beef Burger",
        description: "Carne 100% Angus, queso cheddar, lechuga, tomate, cebolla caramelizada y salsa especial",
        price: 12.99,
        image: "https://images.unsplash.com/photo-1610970878459-a0e464d7592b",
        featured: true
      },
      {
        id: 102,
        name: "BBQ Bacon Burger",
        description: "Doble carne, bacon crujiente, queso pepper jack, aros de cebolla y salsa BBQ ahumada",
        price: 14.99,
        image: "https://images.unsplash.com/photo-1550547660-d9450f859349",
        featured: true
      },
      {
        id: 103,
        name: "Mushroom Swiss Burger",
        description: "Carne premium, champiñones salteados, queso suizo y trufa",
        price: 13.99,
        image: "https://images.unsplash.com/photo-1610970878459-a0e464d7592b"
      },
      {
        id: 104,
        name: "Spicy Jalapeño Burger",
        description: "Carne especiada, jalapeños, queso pepper jack, aguacate y chipotle mayo",
        price: 13.49,
        image: "https://images.unsplash.com/photo-1550547660-d9450f859349"
      }
    ]
  },
  {
    id: 2,
    name: "Pizzas Artesanales",
    slug: "pizzas",
    description: "Masa artesanal, ingredientes importados, horneadas en piedra",
    image: "https://images.unsplash.com/photo-1764705309243-c47cbc9792e4",
    items: [
      {
        id: 201,
        name: "Margherita Premium",
        description: "Salsa de tomate San Marzano, mozzarella di bufala, albahaca fresca y aceite de oliva",
        price: 16.99,
        image: "https://images.unsplash.com/photo-1764705309243-c47cbc9792e4",
        featured: true
      },
      {
        id: 202,
        name: "Pepperoni Deluxe",
        description: "Doble pepperoni, mozzarella, parmesano y orégano",
        price: 17.99,
        image: "https://images.pexels.com/photos/19786235/pexels-photo-19786235.jpeg"
      },
      {
        id: 203,
        name: "Quattro Formaggi",
        description: "Mozzarella, gorgonzola, parmesano y queso de cabra",
        price: 18.99,
        image: "https://images.unsplash.com/photo-1764705309243-c47cbc9792e4"
      },
      {
        id: 204,
        name: "BBQ Chicken Pizza",
        description: "Pollo ahumado, cebolla morada, cilantro y salsa BBQ",
        price: 17.49,
        image: "https://images.pexels.com/photos/19786235/pexels-photo-19786235.jpeg"
      }
    ]
  },
  {
    id: 3,
    name: "Hot Dogs Premium",
    slug: "hotdogs",
    description: "Salchichas artesanales, toppings únicos, experiencia gourmet",
    image: "https://images.unsplash.com/photo-1638368593249-7cadb261e8b3",
    items: [
      {
        id: 301,
        name: "Chicago Style Dog",
        description: "Salchicha premium, pepinillos, tomate, cebolla, jalapeños y mostaza amarilla",
        price: 9.99,
        image: "https://images.unsplash.com/photo-1638368593249-7cadb261e8b3"
      },
      {
        id: 302,
        name: "Chili Cheese Dog",
        description: "Salchicha ahumada, chili con carne, queso cheddar fundido y cebolla crujiente",
        price: 10.99,
        image: "https://images.unsplash.com/photo-1619538189873-3f511db5fec6",
        featured: true
      },
      {
        id: 303,
        name: "New York Dog",
        description: "Salchicha clásica, chucrut, mostaza y cebolla caramelizada",
        price: 9.49,
        image: "https://images.unsplash.com/photo-1638368593249-7cadb261e8b3"
      }
    ]
  },
  {
    id: 4,
    name: "Alitas & Snacks",
    slug: "wings",
    description: "Crujientes por fuera, jugosas por dentro",
    image: "https://images.unsplash.com/photo-1608039755401-742074f0548d",
    items: [
      {
        id: 401,
        name: "Buffalo Wings",
        description: "10 alitas con salsa buffalo picante y aderezo ranch",
        price: 11.99,
        image: "https://images.unsplash.com/photo-1608039755401-742074f0548d",
        featured: true
      },
      {
        id: 402,
        name: "BBQ Honey Wings",
        description: "10 alitas glaseadas con BBQ y miel",
        price: 11.99,
        image: "https://images.unsplash.com/photo-1637273484026-11d51fb64024"
      },
      {
        id: 403,
        name: "Papas Fritas Clásicas",
        description: "Papas cortadas a mano, fritas hasta la perfección",
        price: 4.99,
        image: "https://images.unsplash.com/photo-1630384060421-cb20d0e0649d"
      },
      {
        id: 404,
        name: "Loaded Fries",
        description: "Papas con queso cheddar, bacon, cebollín y crema agria",
        price: 7.99,
        image: "https://images.unsplash.com/photo-1598679253544-2c97992403ea"
      }
    ]
  },
  {
    id: 5,
    name: "Bebidas",
    slug: "drinks",
    description: "Refrescos, batidos y más",
    image: "https://images.pexels.com/photos/4113661/pexels-photo-4113661.jpeg",
    items: [
      {
        id: 501,
        name: "Coca-Cola",
        description: "Refresco clásico bien frío",
        price: 2.99,
        image: "https://images.pexels.com/photos/4113661/pexels-photo-4113661.jpeg"
      },
      {
        id: 502,
        name: "Milkshake de Vainilla",
        description: "Cremoso batido de vainilla con crema batida",
        price: 5.99,
        image: "https://images.pexels.com/photos/9220520/pexels-photo-9220520.jpeg",
        featured: true
      },
      {
        id: 503,
        name: "Limonada Natural",
        description: "Limonada fresca hecha en casa",
        price: 3.49,
        image: "https://images.pexels.com/photos/4113661/pexels-photo-4113661.jpeg"
      }
    ]
  },
  {
    id: 6,
    name: "Postres",
    slug: "desserts",
    description: "El final perfecto para tu comida",
    image: "https://images.unsplash.com/photo-1551024506-0bccd828d307",
    items: [
      {
        id: 601,
        name: "Brownie con Helado",
        description: "Brownie tibio de chocolate con helado de vainilla y salsa de chocolate",
        price: 6.99,
        image: "https://images.unsplash.com/photo-1624353365286-3f8d62daad51",
        featured: true
      },
      {
        id: 602,
        name: "Sundae Supreme",
        description: "Helado con topping de tu elección, crema batida y cereza",
        price: 5.99,
        image: "https://images.unsplash.com/photo-1551024506-0bccd828d307"
      },
      {
        id: 603,
        name: "Brownie Trio",
        description: "Tres brownies gourmet en plato elegante",
        price: 7.99,
        image: "https://images.pexels.com/photos/15106329/pexels-photo-15106329.jpeg"
      }
    ]
  }
];

export const restaurantInfo = {
  name: "TASTE RUSH",
  tagline: "Donde la velocidad encuentra el sabor",
  description: "Experiencia gourmet en comida rápida. Ingredientes premium, sabores auténticos, servicio excepcional.",
  hours: {
    weekdays: "11:00 AM - 11:00 PM",
    weekends: "10:00 AM - 12:00 AM"
  },
  contact: {
    phone: "+1 (555) 123-4567",
    email: "hola@tasterush.com",
    address: "123 Food Street, Ciudad Gourmet"
  },
  social: {
    instagram: "@tasterush",
    facebook: "TasteRushOfficial",
    twitter: "@taste_rush"
  }
};

export const manifesto = [
  {
    number: "01",
    title: "Calidad a precio justo",
    description: "Cada ingrediente es seleccionado cuidadosamente. Trabajamos con proveedores locales para garantizar la frescura y calidad en cada bocado."
  },
  {
    number: "02",
    title: "Rapidez que sorprende",
    description: "Comida rápida no significa sacrificar sabor. Nuestros procesos optimizados garantizan que tu pedido esté listo sin perder la esencia gourmet."
  },
  {
    number: "03",
    title: "Experiencia memorable",
    description: "Más que un restaurante, somos una experiencia. Desde el primer contacto hasta el último bocado, cada detalle está pensado para ti."
  }
];